import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Popconfirm } from 'antd';
import { withRouter } from 'react-router';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import {
	budgetsRestCrudThunksForBuyer,
	budgetsRestCrudThunksForSupplier,
	getBudgetCycle,
} from '../../thunks/budget_thunks';
import { useMemo } from 'react';
import { updateNavbarState } from '../../actions/navbar_actions';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { withUserType } from '../withUserType';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

const queryString = require('qs');

function BudgetDetailPage({
	match,
	currentUser,
	companyConfig,
	fetchBudgetCycle,
	budget,
	loading,
	location,
	history,
	updateNavbar,
	deleteBudget,
	userType,

	childRoutes,
}) {
	const budgetId = match.params.id;
	let searchString = location.search;
	if (searchString[0] === '?') {
		searchString = searchString.slice(1);
	}
	const queryParams = queryString.parse(searchString);

	useMemo(() => {
		fetchBudgetCycle(budgetId, queryParams);
	}, [searchString]);

	let locationName;
	const pathList = history.location.pathname.split('/');
	if (pathList.includes('locations')) {
		const locationId = parseInt(pathList[pathList.indexOf('locations') + 1]);
		if (locationId === 0) {
			locationName = 'Company Wide';
		} else {
			const location = nullSafeGetOrElse('budgetPerLocations', budget, []).find(
				(loc) => loc.locationId === locationId
			);
			locationName = nullSafeGet('name', location);
		}
	} else {
		locationName = undefined;
	}
	useMemo(() => {
		if (locationName) {
			updateNavbar(
				`Back to ${budget.title}`,
				`/${userType}/budgets/detail/${budgetId}/details`.concat(location.search)
			);
		}
	}, [locationName, updateNavbar, budget, userType, budgetId, location.search]);

	return (
		<div>
			<DetailPageHeader
				exactPath={`/${userType}/budgets/detail/:id`}
				redirectPath={`/${userType}/budgets/detail/${budgetId}/details`}
				backLinkText={'Back to budgets'}
				backLinkTo={`/${userType}/workflows/budgets`}
				title={loading ? null : `${budget.title} ${locationName ? `- ${locationName}` : ''}`}
				subtitle={<div></div>}
				subtext={<div className="body1"></div>}
				actions={[
					<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_BUDGET}>
						<Button
							ghost={true}
							style={{ marginBottom: 16, marginRight: 16 }}
							key="reopen"
							onClick={() => history.push(`/${userType}/budgets/edit/${budgetId}`)}
						>
							Edit
						</Button>
					</AccessPermissionChecker>,
					<AccessPermissionChecker name={PERMISSION_NAMES.DELETE_BUDGET}>
						<Popconfirm
							onConfirm={() =>
								deleteBudget(budget).then(() => {
									history.push(`/${userType}/workflows/budgets/overview`);
								})
							}
							placement="topLeft"
							title="Are you sure you want to delete?"
							okText="Yes"
							cancelText="No"
						>
							<Button ghost={true} style={{ marginBottom: 16, marginRight: 16 }} key="delete">
								Delete
							</Button>
						</Popconfirm>
					</AccessPermissionChecker>,
				]}
				tabs={[]}
				backgroundColor={nullSafeGet('detail.config.theme.navblock', companyConfig)}
				handleTabChange={() => {}}
				checkTabActive={() => {}}
				childRoutes={childRoutes}
			/>
		</div>
	);
}

const mapStateToProps = (state, ownProps) => ({
	budget: state.budgets.detail,
	loading: state.budgets.fetching,
	match: ownProps.match,
	history: ownProps.history,
	location: ownProps.location,
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchBudgetCycle: (budgetId, params) =>
		dispatch(getBudgetCycle(ownProps.userType)(budgetId, params)),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	deleteBudget: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? budgetsRestCrudThunksForSupplier.delete(entity, 'id', null, true)
				: budgetsRestCrudThunksForBuyer.delete(entity, 'id', null, true)
		),
});

export default withUserType(
	withRouter(connect(mapStateToProps, mapDispatchToProps)(BudgetDetailPage as any)) as any
);
